<template>
  <div id="steps">
    <ul class="step-container">
      <li
        v-for="(item, index) in steps"
        :key="index"
        :class="{ done: index <= current }"
      >
        <div class="step-item">
          <div
            v-if="index !== 0"
            class="line"
          />
          <div class="circle">
            {{ index + 1 }}
          </div>
          <div class="title">
            {{ $t(`createSellerAccount.steps.${item}`) }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      current: null,
      steps: ['step1', 'step2', 'step3', 'step4', 'step5']
    }
  },
  created() {
    this.current = this.step || 0
  },
  methods: {
    next() {
      if (this.current === this.steps.length) {
        this.current = 0
      } else {
        this.current += 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#steps {
  .step-container {
    display: flex;
    justify-content: center;
    .step-item {
      display: flex;
      align-items: center;
      .circle {
        margin-left: 0.1rem;
        border: 1px solid lightgray;
        border-radius: 50%;
        width: 0.3rem;
        height: 0.3rem;
        line-height: 0.3rem;
        color: lightgray;
        @extend .tc;
      }
      .title {
        margin: 0 0.1rem;
      }
      .line {
        height: 2px;
        width: 0.6rem;
        background-color: $border;
      }
    }
    .done {
      .circle {
        border-color: $themeColor !important;
        background-color: $themeColor !important;
        color: #fff;
      }
      .title {
        font-weight: 600;
      }
      .line {
        background-color: $themeColor;
      }
    }
  }
}
</style>
